import type { ThemeConfig } from "antd";

// Global background color of the whole tool (change this one value if needed)
export const APP_BG = "#F5F6F8";

/**
 * The app-wide antd theme.
 *
 * Everything here is a decision made *once* for every screen. A token changed
 * in this file is the only way a table in Reports and a table in Organisation
 * stay the same table; the alternative — a `size="small"` typed at forty call
 * sites — is how two screens end up disagreeing about what a row looks like.
 */
export const antdTheme: ThemeConfig = {
  token: {
    // Applies to all antd Layout backgrounds app-wide
    colorBgLayout: APP_BG,
  },
  components: {
    Table: {
      // A table is the densest surface in the product and the one people scan
      // rather than read. It used to wear a blue header (#E8F1FB) and #D0D0D0
      // gridlines on *every* cell, which draws a box around every value and
      // makes a list of nine rows look like a spreadsheet of nine hundred.
      //
      // Now: a neutral header that separates itself from the body by tone
      // rather than colour, and hairlines that let the eye run along a row.
      headerBg: "#FAFAFA",
      headerColor: "#1F2937",
      headerSortActiveBg: "#F0F1F3",
      borderColor: "#EFEFEF",
      headerSplitColor: "transparent",
      // 12px of vertical padding rather than 16: about three more rows per
      // screen on a list page, without the rows touching.
      cellPaddingBlock: 12,
      cellPaddingBlockMD: 10,
      cellPaddingBlockSM: 8,
      rowHoverBg: "#F7F9FB",
    },
    // The tab strip is navigation furniture, not content. It was competing
    // with the page title underneath it.
    Tabs: {
      horizontalItemPadding: "6px 12px",
    },
  },
};
